var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7466 4.65972L1.36824 2.92008C0.82133 2.84322 0.440281 2.33755 0.517143 1.79064C0.594005 1.24373 1.09967 0.862682 1.64658 0.939544L14.0249 2.67918C14.5718 2.75604 14.9529 3.26171 14.876 3.80862C14.7992 4.35553 14.2935 4.73658 13.7466 4.65972ZM0.333008 6.50016C0.333008 5.94788 0.780723 5.50016 1.33301 5.50016H13.833C14.3853 5.50016 14.833 5.94788 14.833 6.50016V10.5389V14.5002C14.833 16.157 13.4899 17.5002 11.833 17.5002H3.33301C1.67615 17.5002 0.333008 16.157 0.333008 14.5002V6.50016ZM2.33301 7.50016V14.5002C2.33301 15.0524 2.78072 15.5002 3.33301 15.5002H11.833C12.3853 15.5002 12.833 15.0524 12.833 14.5002V10.5389V7.50016H2.33301ZM5.08321 8.83357C4.53092 8.83357 4.08321 9.28128 4.08321 9.83357C4.08321 10.3859 4.53092 10.8336 5.08321 10.8336H10.0832C10.6355 10.8336 11.0832 10.3859 11.0832 9.83357C11.0832 9.28128 10.6355 8.83357 10.0832 8.83357H5.08321Z",
    fill: "#F5463B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxRed);
export default __webpack_public_path__ + "static/media/box-red.c052d194.svg";
export { ForwardRef as ReactComponent };